/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import ConvocationResignationEligibleFormativeAction from '../model/ConvocationResignationEligibleFormativeAction';
import ConvocationResignationProcess from '../model/ConvocationResignationProcess';
import Error from '../model/Error';

/**
* ConvocationResignations service.
* @module api/ConvocationResignationsApi
* @version 1.0.0
*/
export default class ConvocationResignationsApi {

    /**
    * Constructs a new ConvocationResignationsApi. 
    * @alias module:api/ConvocationResignationsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Get Current Convocation Resignation Active Process
     * Get the current active convocation resignation process, if exists any for the requesting student.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ConvocationResignationProcess} and HTTP response
     */
    convocationResignationsActiveProcessGetWithHttpInfo() {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ConvocationResignationProcess;
      return this.apiClient.callApi(
        '/convocation-resignations/active-process', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get Current Convocation Resignation Active Process
     * Get the current active convocation resignation process, if exists any for the requesting student.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ConvocationResignationProcess}
     */
    convocationResignationsActiveProcessGet() {
      return this.convocationResignationsActiveProcessGetWithHttpInfo()
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Get Eligible Formative Actions For Current Convocation Resignation
     * Get the formative actions that are eligible for the current convocation resignation active process and the requesting student.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/ConvocationResignationEligibleFormativeAction>} and HTTP response
     */
    convocationResignationsEligibleFormativeActionsGetWithHttpInfo() {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [ConvocationResignationEligibleFormativeAction];
      return this.apiClient.callApi(
        '/convocation-resignations/eligible-formative-actions', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get Eligible Formative Actions For Current Convocation Resignation
     * Get the formative actions that are eligible for the current convocation resignation active process and the requesting student.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/ConvocationResignationEligibleFormativeAction>}
     */
    convocationResignationsEligibleFormativeActionsGet() {
      return this.convocationResignationsEligibleFormativeActionsGetWithHttpInfo()
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Create Convocation Resignation Request
     * Create a new convocation resignation request.
     * @param {Array.<File>} justifyingDocs The justifying documentation that prove the reasons why the student needs to resign to the convocations.
     * @param {File} annexDoc The official annex document filled by the student.
     * @param {String} comment The student reason of the resignation request.
     * @param {Object} opts Optional parameters
     * @param {Array.<Number>} opts.ordinaryResignationEnrollIds The enroll ids which are requested for an ordinary convocation resignation.
     * @param {Array.<Number>} opts.extraordinaryResignationEnrollIds The enroll ids which are requested for an extraordinary convocation resignation.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */
    convocationResignationsPostWithHttpInfo(justifyingDocs, annexDoc, comment, opts) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'justifyingDocs' is set
      if (justifyingDocs === undefined || justifyingDocs === null) {
        throw new Error("Missing the required parameter 'justifyingDocs' when calling convocationResignationsPost");
      }
      // verify the required parameter 'annexDoc' is set
      if (annexDoc === undefined || annexDoc === null) {
        throw new Error("Missing the required parameter 'annexDoc' when calling convocationResignationsPost");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling convocationResignationsPost");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'ordinary_resignation_enroll_ids': this.apiClient.buildCollectionParam(opts['ordinaryResignationEnrollIds'], 'csv'),
        'extraordinary_resignation_enroll_ids': this.apiClient.buildCollectionParam(opts['extraordinaryResignationEnrollIds'], 'csv'),
        'justifying_docs': this.apiClient.buildCollectionParam(justifyingDocs, 'csv'),
        'annex_doc': annexDoc,
        'comment': comment
      };

      let authNames = [];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/convocation-resignations', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Create Convocation Resignation Request
     * Create a new convocation resignation request.
     * @param {Array.<File>} justifyingDocs The justifying documentation that prove the reasons why the student needs to resign to the convocations.
     * @param {File} annexDoc The official annex document filled by the student.
     * @param {String} comment The student reason of the resignation request.
     * @param {Object} opts Optional parameters
     * @param {Array.<Number>} opts.ordinaryResignationEnrollIds The enroll ids which are requested for an ordinary convocation resignation.
     * @param {Array.<Number>} opts.extraordinaryResignationEnrollIds The enroll ids which are requested for an extraordinary convocation resignation.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */
    convocationResignationsPost(justifyingDocs, annexDoc, comment, opts) {
      return this.convocationResignationsPostWithHttpInfo(justifyingDocs, annexDoc, comment, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
